import config from 'config';
import requestManager from 'utils/RequestManager';

const authURL = config.AUTH_HOST;


export function deleteTelegramBot(companyId) {
    const request = {
        method: 'DELETE',
        baseURL: authURL,
        url: `/companies/telegram/delete/${companyId}`,
    };

    return requestManager(request).then(res => res.data);
}

export function getTelegramBot(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/telegram/get-token/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function addTelegramBot(botToken, companyId) {
    const request = {
        method: 'POST',
        baseURL: authURL,
        url: `/companies/telegram/add/${companyId}/${botToken}`,
    };

    return requestManager(request).then(res => res.data);
}

export function getWebexBot(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/webex/get-token/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function addWebexBot(botToken, companyId) {
    const request = {
        method: 'POST',
        baseURL: authURL,
        url: `/companies/webex/add/${companyId}/${botToken}`,
    };

    return requestManager(request).then(res => res.data);
}

export function deleteWebexBot(companyId) {
    const request = {
        method: 'DELETE',
        baseURL: authURL,
        url: `/companies/webex/delete/${companyId}`,
    };

    return requestManager(request).then(res => res.data);
}

export function getMessengerBot(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/messenger/get/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function getAllPages(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/messenger/get-all/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function attachMessengerPageToCompany(companyId, pageId) {
    const request = {
        method: 'POST',
        baseURL: authURL,
        url: `/companies/messenger/attach-page/${companyId}?messengerPageId=` + pageId,
    };
    return requestManager(request).then(res => res.data)
}

export function handleFacebookLogout(companyId) {
    const request = {
        method: 'DELETE',
        baseURL: authURL,
        url: `/companies/facebook/delete/account/${companyId}`,
    };
    return requestManager(request).then(res => res.data);
}

export function handleFacebookLogin(tokenData, companyId) {
    const params = new URLSearchParams();
    params.append('userAccessToken', tokenData.userAccessToken);
    const request = {
        method: 'POST',
        baseURL: authURL,
        url: `/companies/facebook/login/${companyId}`,
        params
    };

    return requestManager(request).then(res => res.data);
}

export function getInstagramBot(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/instagram/get/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function getInstagramAllPages(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/instagram/get-all/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function attachInstagramPageToCompany(companyId, instagramId) {
    const request = {
        method: 'POST',
        baseURL: authURL,
        url: `/companies/instagram/attach-page/${companyId}?instagramId=` + instagramId,
    };
    return requestManager(request).then(res => res.data)
}

export function getWhatsAppBot(companyId) {
    const request = {
        method: 'GET',
        baseURL: authURL,
        url: `/companies/whatsapp/get/${companyId}`,
    };
    return requestManager(request).then(res => res.data)
}

export function addWhatsAppBot(whatsAppBotData, companyId) {
    const params = new URLSearchParams();
    params.append('phoneNumberId', whatsAppBotData.phoneNumberId);
    params.append('accessToken', whatsAppBotData.accessToken);
    const request = {
        method: 'POST',
        baseURL: authURL,
        url: `/companies/whatsapp/add/${companyId}`,
        params
    };

    return requestManager(request).then(res => res.data);
}

export function deleteWhatsAppBot(companyId) {
    const request = {
        method: 'DELETE',
        baseURL: authURL,
        url: `/companies/whatsapp/delete/${companyId}`,
    };

    return requestManager(request).then(res => res.data);
}


// WEBPACK FOOTER //
// ./src/services/integrations/api.js